import type { ReceiptTemplate } from '../schema';

export const gucciTemplate: ReceiptTemplate = {
  id: 'gucci',
  name: 'Gucci Receipt',
  brand: 'GUCCI',
  description: 'Luxury fashion receipt template inspired by Gucci stores',
  settings: {
    width: 280,
    font: 'Courier New',
    fontSize: 11,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
  },
  sections: [
    {
      id: 'gucci-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/gucci.png',
        logoData: '',
        logoWidth: 120,
        logoHeight: 60,
        businessName: '',
        businessNameFontSize: 26,
        addressLines: [
          'Gucci Fifth Avenue',
          '725 Fifth Avenue',
          'New York, NY 10022',
          'Tel: (212) 826-2600',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'gucci-info',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'gucci-receipt', label: 'Receipt #:', value: 'GC-2025-00847' },
          { id: 'gucci-date', label: 'Date:', value: '09/30/2025' },
          { id: 'gucci-time', label: 'Time:', value: '02:45 PM' },
          { id: 'gucci-associate', label: 'Associate:', value: 'Maria S.' },
        ],
        column2: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'gucci-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        quantityPosition: 'left',
        showHeader: true,
        showHeaderDivider: true,
        headerLabels: {
          quantity: 'Qty',
          item: 'Description',
          amount: 'Price',
        },
        items: [
          { id: 'gucci-item-1', quantity: '1', name: 'GG Marmont Small Bag', price: '$2,350.00' },
          { id: 'gucci-item-2', quantity: '1', name: 'Horsebit 1955 Wallet', price: '$650.00' },
        ],
        showTopDivider: false,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'gucci-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'left',
        labelPosition: 50,
        lines: [
          { id: 'gucci-subtotal', label: 'Subtotal', value: '3000.00', isBold: false, isLarge: false },
          { id: 'gucci-tax', label: 'Tax (8.875%)', value: '266.25', isBold: false, isLarge: false },
          { id: 'gucci-total', label: 'TOTAL', value: '3266.25', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 40,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'gucci-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'gucci-method', label: 'Payment', value: 'VISA' },
          { id: 'gucci-card', label: 'Card', value: '************8847' },
          { id: 'gucci-auth', label: 'Auth Code', value: '094521' },
          { id: 'gucci-status', label: 'Status', value: 'APPROVED' },
        ],
        cashFields: [
          { id: 'gucci-cash', label: 'Cash', value: '$3500.00' },
          { id: 'gucci-change', label: 'Change', value: '$233.75' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'gucci-message',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Thank you for shopping at Gucci.\n\nReturns accepted within 30 days with original receipt. Items must be unworn with tags attached.\n\nFor assistance: gucci.com/support',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'gucci-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: 'GC202500847',
        showValue: true,
        width: 1.5,
        height: 45,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
  ],
};
